import mixpanel from "mixpanel-browser";

import { ENV_STAGES } from "../constants/Stages";
let key = "b9c093c6e27e65b3136d62bf24432853";
if(window.location.hostname === ENV_STAGES.PROD){
  key = "aeda15c3d686d75ed2a3599eb6bd1cf4";
}

mixpanel.init(key, {
  debug: true,
  track_pageview: true,
});

export default mixpanel;
